export default "__VITE_ASSET__2b683c97__"